/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import styled from "@emotion/styled";
import { useState, useEffect } from "react";
import {
  doGoToPythonPage,
  doGoToJavascriptPage,
  doGoToHomePage,
  doGoToCSSPage,
  doGoToReactPage
} from "../4-redux/actions";
import { connect } from "react-redux";
import {
  PythonIcon,
  JavascriptIcon,
  HomeIcon,
  CSSIcon,
  ReactIcon
} from "./Icons";
import { useScrollHeight, useWindowWidth } from "../3-utils/hookedVariables";
import { Base, Bright, Dark } from "../3-utils/colors";

function Nav({
  goToHomePage,
  goToPythonPage,
  goToJavascriptPage,
  goToCSSPage,
  goToReactPage
}) {
  const scrollHeight = useScrollHeight();
  const windowWidth = useWindowWidth();

  return (
    <Container>
      <StaticNavContainer>
        <Logo onClick={goToHomePage}>
          <b>
            <Base>Stupid</Base>
          </b>
          <div style={{ letterSpacing: "2px", margin: "auto 6px" }}>Simple</div>
          <b>
            <Base>CODE</Base>
          </b>
        </Logo>
        <Options>
          <Item onClick={goToReactPage}>
            <ReactIcon css={navIcon} />
            <p>React Tricks</p>
          </Item>
          <Item onClick={goToPythonPage}>
            <PythonIcon css={navIcon} />
            <p>Python Tricks</p>
          </Item>
          <Item onClick={goToCSSPage}>
            <CSSIcon css={navIcon} />
            <p>CSS Tricks</p>
          </Item>
          <Item onClick={goToJavascriptPage}>
            <JavascriptIcon css={navIcon} />
            <p>Javascript Tricks</p>
          </Item>
        </Options>
      </StaticNavContainer>

      {(scrollHeight > 200 || windowWidth < 600) && (
        <FixedContainer>
          <Options>
            <FixedItem onClick={goToHomePage}>
              <HomeIcon css={navFixedIcon} />
            </FixedItem>
            <FixedItem onClick={goToReactPage}>
              <ReactIcon css={navFixedIcon} />
            </FixedItem>
            <FixedItem onClick={goToPythonPage}>
              <PythonIcon css={navFixedIcon} />
            </FixedItem>
            <FixedItem onClick={goToCSSPage}>
              <CSSIcon css={navFixedIcon} />
            </FixedItem>
            <FixedItem onClick={goToJavascriptPage}>
              <JavascriptIcon css={navFixedIcon} />
            </FixedItem>
          </Options>
        </FixedContainer>
      )}
    </Container>
  );
}

// all it needs is the current page
const select = ({ currentPage }) => ({ currentPage });

// needs to know how to go to the pages
const actions = {
  goToHomePage: doGoToHomePage,
  goToJavascriptPage: doGoToJavascriptPage,
  goToPythonPage: doGoToPythonPage,
  goToCSSPage: doGoToCSSPage,
  goToReactPage: doGoToReactPage
};

export default connect(
  select,
  actions
)(Nav);

const Container = styled.div`
  background-color: var(--background);
  color: white;
`;

// Normal Nav
const StaticNavContainer = styled.div`
  border-bottom: 1px solid #2b2333;
  display: flex;
  @media (max-width: 600px) {
    opacity: 0;
    height: 60px;
    overflow: hidden;
  }
`;

const Item = styled.div`
  transition: 0.2s ease;
  display: inline-block;
  cursor: pointer;
  padding: 0.75em;
  font-size: 30px;
  border-right: 1px solid #2b2333;
  text-align: center;
  &:hover {
    background-color: #2b2333;
  }
  p {
    margin: 0;
    font-size: 18px;
    margin-top: 1em;
  }
`;

const Options = styled.div`
  filter: grayscale(100%);
  &:hover {
    filter: none;
  }
`;

const navIcon = css`
  font-size: 50px;
`;

const Logo = styled(Item)`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  flex-direction: row;
  text-transform: uppercase;
`;

// Fixed Nav on scroll
const FixedItem = styled(Item)`
  font-size: 24x;
  padding: 0.5em;
`;

const navFixedIcon = css`
  font-size: 40px;
`;

const FixedContainer = styled.div`
  background-color: var(--background);
  color: white;
  z-index: 100;
  position: fixed;
  width: 100vw;
  animation: slideDown 0.5s ease;
  top: 0;
  box-shadow: 0 4px 3px rgba(0, 0, 0, 0.5);
  border-bottom: 1px solid #493c56;
  @keyframes slideDown {
    0% {
      top: -100px;
    }
    100% {
      top: 0;
    }
  }
`;
